import Axios from 'axios';
import util from '@/api/util'
import dayjs from 'dayjs'
import { axiosBase } from '@/api/api'
import { getnewuserbindmsg, getusersensitivedata } from '@/port/clientSide/multipleChoice.js'
import { filesConfig, isStandardClass, getClassInfo } from '@/api/global.js'
import { cloneDeep } from 'lodash';
import { sm2 } from 'sm-crypto'

export const statusType = {
  0: {
    text: '处理中',
    class: 'processing'
  },
  1: {
    text: '已完成',
    class: 'passed'
  },
  2: {
    text: '已退回',
    class: 'refuse'
  },
  3: {
    text: '撤回',
    class: 'cancle'
  }
}

export const getCurrentTime = () => {
  const now = new Date();
  const year = now.getFullYear();
  let month = now.getMonth() + 1;
  let date = now.getDate();
  let hour = now.getHours();
  let minute = now.getMinutes();
  let second = now.getSeconds();

  // 将单个数字前面补零
  month = month < 10 ? '0' + month : month;
  date = date < 10 ? '0' + date : date;
  hour = hour < 10 ? '0' + hour : hour;
  minute = minute < 10 ? '0' + minute : minute;
  second = second < 10 ? '0' + second : second;
  return {
    year,
    month,
    date,
    hour,
    minute,
    second
  }
}

export const getCurrentWeather = async () => {
  try {
    let weatherInfo = {}
    const appKey = 'cb620bfd8726bb6a5a74c04f081409bd' // 高德api的key
    // 根据ip获取当前地址
    const ipRes = await Axios.post(`https://restapi.amap.com/v3/ip?key=${appKey}`)

    if (ipRes.data && ipRes.data.status === '1') {
      // 默认给个厦门的地址
      let adcode = 350200
      let city = '厦门市'
      if (ipRes.data.adcode && ipRes.data.adcode !== '[]' && !Array.isArray(ipRes.data.adcode)) {
        adcode = ipRes.data.adcode
        city = ipRes.data.city
      }
      // 根据当前地址获取天气
      const weatherRes = await Axios.post(`https://user.topeti.com/openapi/getweatherinfo?adcode=${adcode}&city=${city}`)
      if (weatherRes.data && weatherRes.data.code === 0) {
        weatherInfo = weatherRes.data.data
      }
    }
    return weatherInfo
  } catch (error) {
    return {}
  }
}

// 根据模板获取初始值 （val 存在则是不获取默认值）
export function momVal(date, val, customData = []) {
    date = [...date]
    let obj = {};
    if (Array.isArray(date)) {
        for (let i = 0; i < date.length; i++) {
        let data = date[i];
        if (data.bindinf === '' && data.bindfield && data.bindfield[0] === '$' && customData.length > 0) {
            // 绑定应用变量
            const name = data.bindfield.split('$')[1]
            const index = customData.findIndex(item => { return item.name === name })
            if (index !== -1) {
            data.bindinf = customData[index].value
            }
        }
        if (data.type === 'image' || data.type === 'file') {
            obj[data.title + '_' + data.type] = [];
        } else if (data.list) {
            let objStr = momVal(data.list)
            if (data.type === 'details' || data.type === 'ready-widget') {
            // 如果是大明细，并且有默认值，就使用大明细默认值
            if (data.type === 'details' && data.isCutDataConfig) {
                let cutDetails = []
                for (const dd of data.cutDataConfig || []) {
                if (dd.dataconfig.setUpValue === 5) {
                    const rra = []
                    for (const rr of dd.bindinf || []) {
                    let bindfield = rr
                    let looktype = 0
                    if (data.bindnewFiled && data.bindnewFiled[1] && isStandardClass(bindfield, 'class')) {
                        bindfield = getClassInfo(bindfield, data.bindnewFiled[1], looktype)
                    }
                    rra.push(assignFormdata(momVal(data.list), bindfield, { tip: dd.i }))
                    }
                    if (rra.length === 0) rra.push({ ...momVal(data.list), tip: dd.i })
                    cutDetails = cutDetails.concat(rra)
                } else {
                    cutDetails.push({ ...momVal(data.list), tip: dd.i })
                }
                }
                obj[data.title + '_' + data.type] = cutDetails
            } else if (data.type === 'details' && data.bindinf.length > 0 && !val) {
                let detailsValArr = []
                data.bindinf.forEach(item => {
                let bindfield = item
                if (data.bindnewFiled && data.bindnewFiled[1] && isStandardClass(bindfield, 'class')) {
                    bindfield = getClassInfo(bindfield, data.bindnewFiled[1])
                }
                detailsValArr.push(assignFormdata(momVal(data.list), bindfield))
                })
                obj[data.title + '_' + data.type] = detailsValArr
            } else {
                obj[data.title + '_' + data.type] = [objStr];
            }
            } else if (data.type === 'new-rel-radio') {
            // 关联单选平级化
            objStr[data.title + '_' + data.type] = null;
            obj = Object.assign(obj, objStr);
            } else if (data.type === 'relation-check') {
            obj[data.title + '_' + data.type] = null
            } else {
            obj[data.title + '_' + data.type] = objStr;
            }
        } else if (data.type === 'checkbox') {
            let vals = data.bindinf;
            if (data.bindnewFiled && data.bindnewFiled[1] && isStandardClass(vals, 'class')) {
            vals = getClassInfo(vals, data.bindnewFiled[1])
            }
            try {
            if (typeof vals === 'string') vals = JSON.parse(vals);
            }
            catch (e) { vals = [] }

            obj[data.title + '_' + data.type] = data.bindinf && !val > 0 ? vals : [];
        } else if (data.type === 'number') {
            obj[data.title + '_' + data.type] = data.defaultValue && !val || data.defaultValue === 0 && !val ? Number(data.defaultValue) : undefined;
        } else {
            let bindfiled = data.bindinf
            if (data.bindnewFiled && data.bindnewFiled[1] && isStandardClass(bindfiled, 'class')) {
            bindfiled = getClassInfo(bindfiled, data.bindnewFiled[1])
            }
            let _date = bindfiled && !val ? formdataValue((data.title + '_' + data.type), bindfiled) : null;
            if (data.type === 'organization' && data.bindfieldKey && !data.bindfieldKey.includes('申请人')) {
            _date = null
            }
            obj[data.title + '_' + data.type] = _date
            if (data.type === 'date') {
            console.log(data.type === 'date' && data.bindinf && data.bindinf.length > 0 && data.timeList && data.timeList.open && data.timeList.defaultValue && obj[data.title + '_' + data.type],'ddddddddddddddd')

            }
            if (data.type === 'date' && data.bindinf && data.bindinf.length > 0 && data.timeList && data.timeList.open && data.timeList.defaultValue && obj[data.title + '_' + data.type]) {
            try {
                const eee = (obj[data.title + '_' + data.type]).split(' ')
                eee[1] = data.timeList.defaultValue
                obj[data.title + '_' + data.type] = eee.join(' ')
            } catch (err) { 
              // TODO
            }
            } else if (data.type === 'relation-user' && data.bindfieldList && data.bindfieldList.length > 0 && obj[data.title + '_' + data.type].length > 0) {
            const userInfoKeys = {
                '姓名': 'realname',
                '登录名': 'username',
                '联系电话': 'realphone',
                '出生日期': 'birthday',
                '身份证': 'realidcard',
                '性别': 'sex'
            }
            const bindfieldList = data.bindfieldList
            getnewuserbindmsg({ userId: obj[data.title + '_' + data.type][0].userId }).then(res => {
                let looktype = 0
                const info = cloneDeep(res.data)
                for (const key in res.data) {
                if (key === '部门：班级' && res.data[key][0]) {
                    looktype = res.data[key][0].looktype
                }
                if (key.includes('部门')) {
                    if (res.data[key][0]) {
                    info[key] = res.data[key][0].name
                    } else {
                    info[key] = ''
                    }
                }
                }
                const userInfo = info
                bindfieldList.forEach(async item => {
                // 跟绑定的那个控件做个匹配
                const fliedIndex = date.findIndex(ruleItem => { return `${ruleItem.title}_${ruleItem.type}` === item })
                if (fliedIndex !== -1) {
                    const flied = date[fliedIndex]
                    // 两边不匹配就返回
                    if (flied.bindfieldKey !== `${data.title}_${data.type}`) return false
                    const bindfield = flied.bindfield // 要回填的字段
                    // 联动出来的没有该字段 去请求一下
                    let value = userInfo[bindfield] !== undefined ? userInfo[bindfield] : userInfo[userInfoKeys[bindfield]]
                    if (bindfield === '性别') {
                    value = value ? '女' : '男'
                    }
                    if (value && value.search('userfiles') !== -1) {
                    value = this.$url + value.replace('userfiles', 'conflies')
                    }
                    const bindnewFiled = flied.bindnewFiled
                    if (bindnewFiled && bindnewFiled[1] && isStandardClass(value, 'class')) {
                    value = getClassInfo(value, bindnewFiled[1], looktype)
                    }
                    if (item.includes('organization')) {
                    value = res.data['部门']
                    }
                    obj[item] = value
                }
                })
            })
            }
        }
        }
    }
    return obj;
}

// 根据对应格式格式化对应值
export function formdataValue(formdata, val, formdataVal) {
    let formdataType = formdata.split('_')[1]
    if (formdataType === 'text' || formdataType === 'textares') return (val || val === 0 ? val : '').toString()
    if (formdataType === 'number') {
      if (val === '') return ''
      return Number(val)
    }
    // 时间格式写死的，针对时：分 的固定格式 1970-01-01 (如果出现其他场景需要这个时间，再考虑兼容，有问题找后台)
    if (formdataType === 'date' && val && val.includes('1970-01-01')) {
      return val.split(' ')[1]
    }
    if (formdataType === 'details') {
      let vals = [];
      for (let i = 0; i < val.length; i++) {
        if (!Array.isArray(val[i]) && typeof val[i] === 'object') {
          let forVal = assignFormdata((formdataVal[i] || clearValue(formdataVal[0])), val[i]);
          vals.push(JSON.parse(JSON.stringify(forVal)));
        }
      }
      return vals;
    }
    if (formdataType === 'file' || formdataType === 'image') {
      return uploaderFun(val, formdataType)
    }
    // 兼容之前的失误提交，是对象直接给（用数组包上）
    if (formdataType === 'ready-widget') {
      if (Array.isArray(val)) {
        return val;
      } else {
        return [val];
      }
    }
    // 关联多选值更改版本，如果是对象里面有 data 并且是数组里面有 response 就认为她是图片组件
    if (formdataType === 'relation-check' && val && val.data && val.data.length > 0) {
      val.data = val.data.map(its => {
        for (const ite in its) {
          if (its[ite] && Array.isArray(its[ite]) && its[ite][0] && its[ite][0].response) {
            its[ite] = uploaderFun(its[ite], 'image')
          }
        }
        return its
      })
    }
    return val;
}
//生成时间段 30分钟
// 数字格式是否是万元格式
export function isWY(item) {
    return item.format && item.format.value === 'currency' && item.format.currency === '万元'
}
//生成时间段
export function generateTime() {
    const arr = ['00:00']
    const date = new Date()
    let zero = new Date(date.getFullYear() + '/' + (date.getMonth() + 1) + '/' + date.getDate()).getTime()
    const endTime = (zero + 60 * 60 * 24 * 1000 - 30 * 60 * 1000)
    while (zero < endTime) {
        zero += (30 * 60 * 1000)
        let hour = new Date(zero).getHours()
        let minutes = new Date(zero).getMinutes()
        if (hour.toString().length < 2) {
        hour = '0' + hour
        }
        if (minutes.toString().length < 2) {
        minutes = '0' + minutes
        }
        arr.push(hour + ':' + minutes)
    }
    arr.push('23:59')
    return arr
}

// 生成时间段 10 分钟
export function generateTime10() {
    const arr = ['00:00']
    const date = new Date()
    let zero = new Date(date.getFullYear() + '/' + (date.getMonth() + 1) + '/' + date.getDate()).getTime()
    const endTime = (zero + 60 * 60 * 24 * 1000 - 10 * 60 * 1000)
    while (zero < endTime) {
        zero += (10 * 60 * 1000)
        let hour = new Date(zero).getHours()
        let minutes = new Date(zero).getMinutes()
        if (hour.toString().length < 2) {
        hour = '0' + hour
        }
        if (minutes.toString().length < 2) {
        minutes = '0' + minutes
        }
        arr.push(hour + ':' + minutes)
    }
    arr.push('23:59')
    return arr
}

// 生成时间段 一小时
export function generateTime60() {
  const arr = ['00:00']
  const date = new Date()
  let zero = new Date(date.getFullYear() + '/' + (date.getMonth() + 1) + '/' + date.getDate()).getTime()
  const endTime = (zero + 60 * 60 * 24 * 1000 - 60 * 60 * 1000)
  while (zero < endTime) {
    zero += (60 * 60 * 1000)
    let hour = new Date(zero).getHours()
    let minutes = new Date(zero).getMinutes()
    if (hour.toString().length < 2) {
      hour = '0' + hour
    }
    if (minutes.toString().length < 2) {
      minutes = '0' + minutes
    }
    arr.push(hour + ':' + minutes)
  }
  arr.push('23:59')
  return arr
}

// file and image 获取值拆解
export function uploaderFun(val, type) { // type 为image 就需要加token
    if (!val || val === '[]' || val === '') return [];
    let arr = [];
    try {
      val = JSON.parse(val);
    }
    catch (e) {
      // TODO
     }
    if (typeof val === 'string') {
      arr.push(getUrl({ url: val, name: val }, type))
    } else {
      val.forEach(e => {
        if (e) {
          let subStr = e.response ? { ...e } : { response: e }
          subStr = getUrl(subStr, type)
          arr.push(subStr);
        }
      })
    }
    return arr;
}

// 模板置空（给值清空使用的）
function clearValue(val) {
    for (const i in val) {
      const type = i.split('_')[1]
      if (val[i]) {
        if (type === 'checkbox' || type === 'image' || type === 'file') {
          val[i] = []
        } else {
          val[i] = ''
        }
      }
    }
    return val
}

// 文件 图片拼 url (uploaderFun 使用)
function getUrl(val, type) {
  let subStr = { ...val } // 创建对象的副本
  try {
    subStr.url = (subStr.response.indexOf('http') == -1 ? util.apiUrl() + subStr.response : subStr.response) + (type === 'image' ? '?accesstoken=' + filesConfig() : '')
    // subStr.name = subStr.response.substring(subStr.response.indexOf("-") + 1);
    subStr.name = subStr.realname ? subStr.realname : subStr.response.substring(subStr.response.indexOf("-") + 1);
  } catch (error) { 
    console.log('substring解析错误', error) 
  }
  return subStr;
}

/**
 * 更新新版单选，如果是选项模板下的值进行匹配
 */
function selsMatching({ dataconfig, sels }) {
    const selsConfig = {}
    let selse = []
    try { selse = JSON.parse(sels) } catch (e) { selse = sels }
    for (const si of dataconfig.selsConfig || []) {
      selsConfig[si.value] = si
    }
    selse = selse.map(its => {
      const obs = {
        label: its,
        value: its
      }
      if (selsConfig[its]) {
        obs.label = selsConfig[its].label
      }
      return obs
    })
    return selse
}

/***
 * 暂存等获取 单选-其他
 * template 模板 formdata 值 install 唯一标题（校验规则上配置，该参数不存在则不进行值判断）
 */

export function setOthersFormdata(template, formdata, install) {
    let othersObj = {};
    let isInstall = install && install.addCheckNameUnique && install.addCheckNameUnique.checkList ? install.addCheckNameUnique.checkList : '';
    let isNameCto = [];
    let associationVisible = { key: -1, value: {}, select: {} }//选项显示隐藏控制
    const cutObj = {} // 单多选选项卡片模式
    if (Array.isArray(template)) {
      for (let i = 0; i < template.length; i++) {
        let info = template[i];
        let type = info.title + '_' + info.type;
        if (isInstall !== '' && isInstall.indexOf(info.title) !== -1) {
          template[i].onlyTitle = true;
        }
        if (info.type === "relation-user" && info.isInformRel === 2) {
          isNameCto.push(info.title + "_" + info.type);
        }
        if (info.type === 'radio' && info.others) {
          let othersVal = JSON.parse(JSON.stringify(formdata[type]));
          let sels = info.sels || [];
          try { sels = JSON.parse(info.sels); } catch (e) { 
            // TODO
          }
          if (othersVal && sels.findIndex(ita => (ita.value || ita) === othersVal) === -1) {
            template[i].othersVal = othersVal;
            formdata[type] = 'others其他';
          }
        }
        if (info.type === 'radio' && info.dataconfig && info.dataconfig.setUpValue && info.dataconfig.setUpValue === 2 && info.dataconfig.selsConfig) {
          info.sels = selsMatching(info)
        }
        if (info.type === 'new-rel-radio' && info.list && info.list.length > 0) {
          (info.list).forEach((val) => {
            let types = val.title + '_' + val.type;
            if (val.type === 'radio' && val.others) {
              let othersVal = JSON.parse(JSON.stringify(formdata[types]));
              let sels = val.sels || [];
              try { sels = JSON.parse(val.sels); } catch (e) { 
                // TODO
              }
              if (othersVal && sels.findIndex(ita => (ita.value || ita) === othersVal) === -1) {
                val.othersVal = othersVal;
                formdata[types] = 'others其他';
              }
            }
            if (val.type === 'radio' && val.dataconfig && val.dataconfig.setUpValue && val.dataconfig.setUpValue === 2 && val.dataconfig.selsConfig) {
              val.sels = selsMatching(val)
            }
          })
        }
        if ((info.type === 'radio' || info.type === 'checkbox') && info.isCut) {
          cutObj[info.title] = info.cutList && info.cutList.length > 0 ? info.cutList[0].label : ''
        }
        if (info.type === 'details' && info.list && info.list.length > 0) {
          (info.list).forEach(vals => {
            let detailsType = info.title + '_' + info.type;
  
            if (vals.type === 'relation-user' && vals.isInformRel === 2) {
              isNameCto.push(type + '.' + vals.title + '_' + vals.type);
            }
            if (vals.type === 'radio' && vals.others) {
              let types = vals.title + '_' + vals.type;
              let sels = vals.sels || [];
              try { sels = JSON.parse(vals.sels) } catch (e) {
                // TODO
               }
              if (formdata[detailsType] && formdata[detailsType].length > 0) {
                for (let a = 0; a < formdata[detailsType].length; a++) {
                  let othersVal = JSON.parse(JSON.stringify(formdata[detailsType][a][types]));
                  if (othersVal && sels.findIndex(ita => (ita.value || ita) === othersVal) === -1) {
                    if (!othersObj[detailsType]) othersObj[detailsType] = [];
                    if (!othersObj[detailsType][a]) othersObj[detailsType][a] = {};
                    othersObj[detailsType][a][types] = othersVal;
                    formdata[detailsType][a][types] = 'others其他';
                  }
                }
              }
            }
            if (vals.type === 'radio' && vals.dataconfig && vals.dataconfig.setUpValue && vals.dataconfig.setUpValue === 2 && vals.dataconfig.selsConfig) {
              vals.sels = selsMatching(vals)
            }
            if (vals.type === 'new-rel-radio' && vals.list && vals.list.length > 0) {
              (vals.list).forEach(newVals => {
                if (newVals.type === 'radio' && newVals.others) {
                  let types = newVals.title + '_' + newVals.type;
                  let sels = newVals.sels || [];
                  try { sels = JSON.parse(newVals.sels) } catch (e) {
                    // TODO
                   }
                  if (formdata[detailsType] && formdata[detailsType].length > 0) {
                    for (let a = 0; a < formdata[detailsType].length; a++) {
                      let othersVal = JSON.parse(JSON.stringify(formdata[detailsType][a][types]));
                      if (othersVal && sels.findIndex(ita => (ita.value || ita) === othersVal) === -1) {
                        if (!othersObj[detailsType]) othersObj[detailsType] = [];
                        if (!othersObj[detailsType][a]) othersObj[detailsType][a] = {};
                        othersObj[detailsType][a][types] = othersVal;
                        formdata[detailsType][a][types] = 'others其他';
                      }
                    }
                  }
                }
                if (newVals.type === 'radio' && newVals.dataconfig && newVals.dataconfig.setUpValue && newVals.dataconfig.setUpValue === 2 && newVals.dataconfig.selsConfig) {
                  newVals.sels = selsMatching(newVals)
                }
              })
            }
            if ((vals.type === 'radio' || vals.type === 'checkbox') && vals.isCut) {
              cutObj[info.title + '_' + vals.title] = vals.cutList && vals.cutList.length > 0 ? vals.cutList[0].label : ''
            }
          })
        }
        if (info.type === 'ready-widget' && info.list && info.list[0] && info.list[0].isCut) {
          cutObj[info.list[0].title] = info.list[0].cutList && info.list[0].cutList.length > 0 ? info.list[0].cutList[0].label : ''
        }
        if (info.associationVisible && info.associationVisible.associationswitch) {//如果打开了隐藏显示
          associationVisible.select[type] = {};
          associationVisible.value[type] = formdata[type] == 'others其他' ? template[i].othersVal : formdata[type];
          if (associationVisible.key < 0) {
            associationVisible.key = i
          }
          info.associationVisible.Visiblel.forEach(item => {
            associationVisible.select[type][item.key] = item.value
          })
        }
      }
    }
    return {
      template: template,
      formdata: formdata,
      othersObj: othersObj,
      isNameCto: isNameCto,
      associationVisible: associationVisible,
      cutObj: cutObj
    }
}
/**
* 日期限制
* '' 无 week 本周 nextWeek 下周 month 本月 nextMonth 下月 next30 往后30天 next7 往后7天
 * 周日 getDay() 为 0 需要兼容下
 * type 有值代表只需要返回开始和结束时间，没值则是 element 插件使用的
* */
export function limitDate(val, type, isJexcel) {
    let date = new Date();
    let day = date.getDay();
  
    let stat = Date.now() - 8.64e7;
    let threeMonths = '';
    if (val === 'next30' || val === 'next7') {
      let str = val === 'next7' ? 6 : 29;
      let curDate = (new Date()).getTime();
      let three = str * 24 * 3600 * 1000;
      threeMonths = curDate + three;
    }
    if (val === 'last30' || val === 'last7') {
      let str = val === 'last7' ? 7 : 30;
      let curDate = (new Date()).getTime();
      let three = str * 24 * 3600 * 1000;
      threeMonths = Date.now()
      stat = curDate - three
    }
    // 下周几以后的开始时间走下周逻辑（有问题问孙）
    if (val === 'week' || val === 'nextWeek' || val === 'dayWeek') {
      let dates = val === 'nextWeek' || val === 'dayWeek' ? date.getTime() + (7 * 24 * 3600 * 1000) : date.getTime();
      let num = day !== 0 ? day : 7;
      // 小于本周
      if (type > num) {
        num = 7 - (type - num) + 1;
      } else {
        num -= (Number(type) - 1);
      }
      let statNum = dates - (num * 24 * 3600 * 1000);
      stat = new Date(statNum);
      threeMonths = new Date(statNum + (7 * 24 * 3600 * 1000));
    }
  
    if (val === 'month') {
      stat = new Date(new Date().setDate(0));
      // 获取下个月的第一天
      threeMonths = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    }
  
    if (val === 'nextMonth') {
      stat = new Date(date.getFullYear(), date.getMonth() + 1, 0).getTime() + 8.64e7;
      if (isJexcel) stat -= 8.64e7;
      threeMonths = new Date(date.getFullYear(), date.getMonth() + 2, 0);
    }
  
    // 因为他的格式不同，所以单独下
    if (val === 'dayWeek') {
      if (!isJexcel) {
        return {
          disabledDate: (time) => {
            return time.getTime() < stat;
          }
        }
      } else {
        return {
          stat: stat,
          end: ''
        }
      }
    }
    if (val === 'next1') {
      let curDate = (new Date()).getTime();
      let three = 1 * 24 * 3600 * 1000;
      threeMonths = curDate + three;
      stat = curDate
    }
  
    if (!isJexcel) {
      return {
        disabledDate: (time) => {
          if (!threeMonths || !val) return '';
          return time.getTime() < stat || time.getTime() > threeMonths;
        }
      }
    } else {
      return {
        stat: stat,
        end: threeMonths
      }
    }
}
/**
 * 不包含本日的返回开始时间
 * */
export function thisNoTime(val) {
  let date = new Date();
  if (val === 'nextMonth') {
    return new Date(date.getFullYear(), date.getMonth() + 1, 0).getTime() + 8.64e7;
  }
  if (val === 'nextWeek') {
    let day = date.getDay();
    let num = 8 - (day !== 0 ? day : 7);
    return date.getTime() + (num * 24 * 3600 * 1000);
  }
  console.log('thisNoTime===', date)
  return date;
}

/**
 * 提交时的其他赋值
 * tem 模板 info 显示的数据对标formdata others 存放其他的对标othersObj
 * 如果时间控件 match 为 时分配置，则转化下值
 * */
import { formatDate } from './global'
export function othersRed(tem, info, others) {
  for (let i = 0; i < tem.length; i++) {
    let type = tem[i].title + '_' + tem[i].type;
    if (tem[i].type === 'date' && tem[i].match && tem[i].match === 'HH:mm' && info[type]) {
      try {
        const dd = new Date(0)
        const vdd = info[type].split(':')
        dd.setHours(vdd[0])
        dd.setMinutes(vdd[1])
        info[type] = formatDate(dd, 'yyyy-MM-dd hh:mm:ss')
      } catch (err) { console.log(err) }
    }
    if (tem[i].type === 'radio' && tem[i].others && info[type] === 'others其他') {
      info[type] = tem[i].othersVal;
    }
    if (tem[i].type === 'new-rel-radio' && tem[i].list && tem[i].list.length > 0) {
      (tem[i].list).forEach(vals => {
        if (tem[i].type === 'date' && tem[i].match && tem[i].match === 'HH:mm' && info[type]) {
          try {
            const dd = new Date(0)
            const vdd = (info[vals.title + '_' + vals.type]).split(':')
            dd.setHours(vdd[0])
            dd.setMinutes(vdd[1])
            info[vals.title + '_' + vals.type] = formatDate(dd, 'yyyy-MM-dd hh:mm:ss')
          } catch (err) { console.log(err) }
        }
        if (vals.type === 'radio' && vals.others && info[vals.title + '_' + vals.type] === 'others其他') {
          info[vals.title + '_' + vals.type] = vals.othersVal;
        }
      })
    }
    // 如果是明细，去看看有没有对应值
    if (tem[i].type === 'details' && others[type] && others[type].length > 0) {
      (others[type]).forEach((vals, index) => {
        for (let a in vals) {
          if (vals[a] || vals[a] === '' || vals[a] === undefined) {
            info[type][index][a] = vals[a];
          }
        }
      })
    }
    // 明细也检查一次时间
    if (tem[i].type === 'details' && tem[i].list && tem[i].list.length > 0 && info[type] && info[type].length > 0) {
      for (let r = 0; r < info[type].length; r++) {
        if (!Array.isArray(info[type][r])) {
          for (const a of tem[i].list) {
            const dType = a.title + '_' + a.type
            if (a.type === 'date' && a.match === 'HH:mm' && info[type][r][dType]) {
              try {
                const dd = new Date(0)
                const vdd = (info[type][r][dType]).split(':')
                dd.setHours(vdd[0])
                dd.setMinutes(vdd[1])
                info[type][r][dType] = formatDate(dd, 'yyyy-MM-dd hh:mm:ss')
              } catch (err) { console.log(err) }
            }
            if (a.list && a.list.length > 0) {
              for (const e of a.list) {
                const eType = e.title + '_' + e.type
                if (e.type === 'date' && e.match === 'HH:mm' && info[type][r][eType]) {
                  try {
                    const dd = new Date(0)
                    const vdd = (info[type][r][eType]).split(':')
                    dd.setHours(vdd[0])
                    dd.setMinutes(vdd[1])
                    info[type][r][eType] = formatDate(dd, 'yyyy-MM-dd hh:mm:ss')
                  } catch (err) { console.log(err) }
                }
              }
            }
          }
        }
      }
    }
  }
  return info;
}

/** 拷贝值
 *  此函数了为了解决 number 组键的值变成 undefined 之后拷贝丢失值使用的拷贝含数
 * */
export function copyObj(val) {
    if (typeof val !== 'object' || val === null) return val;
    if (Array.isArray(val)) {
      let arr = [];
      for (let i = 0; i < val.length; i++) {
        if (typeof val[i] !== 'object' || Array.isArray(val[i])) {
          arr.push(val[i]);
        } else {
          const ars = copyObj(val[i]);
          arr.push(ars);
        }
      }
      return arr;
    } else {
      let obj = {};
      for (let i in val) {
        if (typeof val[i] !== 'object') {
          obj[i] = val[i] === undefined ? '' : val[i];
        } else {
          obj[i] = copyObj(val[i]);
        }
      }
      return obj;
    }
}

/***
 * object 去重（利用键名不能重复特点）
 * val 需要去重的数组[{a:1},{a:1}]
 * name 键名 a
 */
export function unique(val, name) {
    let result = {};
    let finalResult = [];
    for (let i = 0; i < val.length; i++) {
      result[val[i][name]] = val[i];
    }
  
    for (let i in result) {
      finalResult.push(result[i]);
    }
    return finalResult;
}

// 提交时转化格式
export function formatConversion(val, associationVisible) {
    for (let i in val) {
      let formdataType = i.split('_')[1];
      if (val[i] === null || val[i] === undefined) {
        val[i] = ''
      } else if (formdataType === 'file' || formdataType === 'image') {
        val[i] = postFun(val[i])
      } else if (formdataType === 'details') {
        let vals = JSON.parse(JSON.stringify(val[i]));
        // 明细的值还需要走一次格式转化
        for (let el = 0; el < vals.length; el++) {
          vals[el] = formatConversion(vals[el]);
        }
        // 是明细的话要加一个固定数组 (拿他的第一组加)
        let obj = [];
        for (let a in val[i][0]) {
          obj.push(a);
        }
        vals.push(obj)
        val[i] = JSON.stringify(vals);
      } else if (formdataType === 'ready-widget') { // 预约也要走
        if (Array.isArray(val[i]) && val[i].length > 1) {
          val[i] = JSON.stringify(val[i]);
        } else {
          let vals = JSON.parse(JSON.stringify(val[i]));
          let obj = [];
          for (let a in val[i][0]) {
            obj.push(a);
          }
          vals.push(obj);
          val[i] = JSON.stringify(vals);
        }
      } else if (formdataType === 'relation-check' && val[i] && val[i].data && val[i].data.length > 0) {
        // 关联多选里面有图片控件，需要便利出来处理下
        const data = []
        for (const d of val[i].data) {
          for (const di in d) {
            if (Array.isArray(d[di]) && d[di][0] && d[di][0].url && d[di][0].response && d[di][0].name) {
              d[di] = postFun(d[di])
            }
          }
          data.push(d)
        }
        val[i].data = data
        val[i] = JSON.stringify(val[i])
      } else if (typeof val[i] === 'object') {
        val[i] = JSON.stringify(val[i]);
      }
      if (associationVisible && associationVisible.key !== -1) {
        if (associationVisible.value[i] !== undefined) {
          if (!associationVisible.value[i]) {
            delete val[i]
          }
        }
      }
    }
    return val;
}

// 是否同步关于我的
export function countRule(rule, formdata, arr) {
    if (!rule || !formdata) return '';
    let arrs = JSON.parse(JSON.stringify(arr));
    for (let i = 0; i < rule.length; i++) {
      if (rule[i].type === 'relation-user' && rule[i].isInformRelWy == 2) {
        const info = formdata[rule[i].title + '_' + rule[i].type];
        if (info && info.length > 0) {
          arrs = arrs.concat(info);
        }
      } else if (rule[i].type === 'new-rel-radio' && rule[i].list && rule[i].list.length > 0) {
        arrs = countRule(rule[i].list, formdata, arrs);
      } else if (rule[i].type === 'details' && rule[i].list && rule[i].list.length > 0) {
        arrs = countRule(rule[i].list, formdata[rule[i].title + '_' + rule[i].type], arrs);
      }
    }
    // 去重
    arrs = unique(arrs, 'userId');
    return arrs;
  }
  
  // 比对赋值
  export function assignFormdata(formdata, val, defaultForm = {}) {
    for (let i in formdata) {
      let vals = val[i];
      if (val[i] || vals === '' || vals === null || vals === 0) {
        try {
          // 走一次格式校验
          if (typeof JSON.parse(vals) === "number") {
            formdata[i] = formdataValue(i, vals, formdata[i]);
          } else {
            formdata[i] = formdataValue(i, JSON.parse(vals), formdata[i]);
          }
        }
        catch (e) {
          formdata[i] = formdataValue(i, vals, formdata[i]);
        }
      } else if(i && i.includes('number') && formdata[i] === ''){
        formdata[i] = undefined
      }
    }
    formdata = { ...formdata, ...defaultForm }
    if (!formdata.linktype && val.linktype) formdata.linktype = val.linktype
    return formdata;
}

// file and image 提交值拆解
export function postFun(val) {
  if (!val || !Array.isArray(val)) return []
  let fileList = []
  val.forEach(item => {
    if (item.response) {
      let fileObj = { response: item.response }
      if (item.signet) {
        fileObj.signet = item.signet
      }
      fileList.push(fileObj)
    }
  });
  return fileList;
}

// 字符串转arrbuffer
export function stringToArrayBuffer(str) {
  var bytes = new Array();
  var len, c;
  len = str.length;
  for (var i = 0; i < len; i++) {
    c = str.charCodeAt(i);
    if (c >= 0x010000 && c <= 0x10FFFF) {
      bytes.push(((c >> 18) & 0x07) | 0xF0);
      bytes.push(((c >> 12) & 0x3F) | 0x80);
      bytes.push(((c >> 6) & 0x3F) | 0x80);
      bytes.push((c & 0x3F) | 0x80);
    } else if (c >= 0x000800 && c <= 0x00FFFF) {
      bytes.push(((c >> 12) & 0x0F) | 0xE0);
      bytes.push(((c >> 6) & 0x3F) | 0x80);
      bytes.push((c & 0x3F) | 0x80);
    } else if (c >= 0x000080 && c <= 0x0007FF) {
      bytes.push(((c >> 6) & 0x1F) | 0xC0);
      bytes.push((c & 0x3F) | 0x80);
    } else {
      bytes.push(c & 0xFF);
    }
  }
  var array = new Int8Array(bytes.length);
  for (let i = 0; i <= bytes.length; i++) {
    array[i] = bytes[i];
  }
  return array.buffer;
}
// 文件地址转blob
export function urlToBinary(url) {
  return fetch(url)
    .then(response => response.blob())
    .then(blob => new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    }));
}
// 将配置信息转为文件并上传
export function stringToArrayBufferUpLoad(str, options = { }) {
  return new Promise((resolve, reject) => {
    const { fileName, isGetFileName } = options
    const congfigArrayBuffer = stringToArrayBuffer(JSON.stringify(str))
    const token = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')).accesstoken : ''
    const url = '/userfile/upload?accesstoken='+token
    const name = `${fileName}.txt` || 'config.txt'
    const file = new File([congfigArrayBuffer], name, {
      type: 'text/plain'
    })
    const formData = new FormData()
    formData.append("file", file)
    let config = {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    };
    Axios.post(url, formData, config)
      .then(res => {
        const configUrl = isGetFileName ? res.data : `/userfiles/${res.data}`
        resolve(configUrl)
      })
      .catch(err => {
        reject(err)
      })
  })


}
// 根据url获取配置信息
export function getConfigFromUrl(url, accesstoken) {
  return new Promise((resolve, reject) => {
    // 下载配置添加token
    const host = document.domain
    // 集美外网使用和外网相同的域名
    const jimeiHost = ['mh.xmjmedu.com', 'xmjmedu.com']
    if (jimeiHost.includes(host) && url) {
      url = url.replace('guanli.xmjmedu.com', host)
    }
    url = url.replace('userfiles', 'confiles')
    const user = window.localStorage.getItem('user')
    if (user || accesstoken) {
      accesstoken = accesstoken || JSON.parse(user).accesstoken
      url += `?accesstoken=${accesstoken}`
    }
    // if (openid) url += `&openid=${openid}`
    var result = null;
    var blob = null;
    var xhr = new XMLHttpRequest();
    xhr.open("GET", url);
    xhr.responseType = "blob";
    // 加载时处理
    xhr.onload = () => {
      // 获取返回结果
      blob = xhr.response;
      var reader = new FileReader();
      reader.readAsText(blob, 'utf-8');//发起异步请求
      reader.onload = function () {
        // 返回结果
        if (strIsJSON(this.result)) {
          result = JSON.parse(this.result);
        }
        resolve(result);
      }
    };
    xhr.onerror = (e) => {
      reject(e)
    };
    // 发送
    xhr.send();
  });
}

export const strIsJSON = (str) => {
  try {
    JSON.parse(str);
  } catch (e) {
    // 转换出错，抛出异常
    return false;
  }
  return true;
}

export const isJSON = (str) => {
  const res = typeof str === 'string' && str !== '' ? JSON.parse(str) : str
  return res
}

// 退出登陆清空参数
export function signOut() {
  return new Promise((resolve, reject) => {
    const list = localStorage.getItem('userList')
    const historymsg = localStorage.getItem('historymsg')
    axiosBase({}, "/openapi/logout").then(res => {
      if (res.code === 0) {
        localStorage.removeItem("user");
        localStorage.clear();
        sessionStorage.clear();
        if (list) localStorage.setItem('userList', list)
        if (historymsg) localStorage.setItem('historymsg', historymsg)
        resolve();
      } else {
        reject(res.msg);
      }
    }).catch(error => {
      reject(error);
    });
  });
}

// 双十单点登出
export function xmssOut() {
  const baseUrl = 'https://xm.sszx.cn/data-center/#/oauth/logout'
  const params = new URLSearchParams({
    clientId: 'cQ5bW9cV5hK1fY9r',
    redirectUrl: 'https://xm.sszx.cn/data-center/#/login'
  })
  window.location.href = `${baseUrl}?${params.toString()}`
}

/**
 * 大陆身份证/台湾居民来往大陆通行证（台胞证）、或港澳居民往来内地通行证（回乡证）/护照
 * */
export function isCardIDTwo(val) {
  return val && val.length >= 7;
}

/**
 * 身份证验证
 * */
export function isCardID(idCard) {
  // 15位和18位身份证号码的正则表达式
  const regIdCard = /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/
  // 如果通过该验证，说明身份证格式正确，但准确性还需计算
  if (regIdCard.test(idCard)) {
    if (idCard.length === 18) {
      // eslint-disable-next-line no-array-constructor
      const idCardWi = new Array(7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2) // 将前17位加权因子保存在数组里
      // eslint-disable-next-line no-array-constructor
      const idCardY = new Array(1, 0, 10, 9, 8, 7, 6, 5, 4, 3, 2) // 这是除以11后，可能产生的11位余数、验证码，也保存成数组
      let idCardWiSum = 0 // 用来保存前17位各自乖以加权因子后的总和
      for (let i = 0; i < 17; i++) {
        idCardWiSum += idCard.substring(i, i + 1) * idCardWi[i]
      }
      const idCardMod = idCardWiSum % 11 // 计算出校验码所在数组的位置
      const idCardLast = idCard.substring(17) // 得到最后一位身份证号码
      // 如果等于2，则说明校验码是10，身份证号码最后一位应该是X
      // eslint-disable-next-line eqeqeq
      if (idCardMod == 2) {
        if (idCardLast === 'X' || idCardLast === 'x') {
          return true
        } else {
          return '身份证号码错误！'
        }
      } else {
        // 用计算出的验证码与最后一位身份证号码匹配，如果一致，说明通过，否则是无效的身份证号码
        // eslint-disable-next-line eqeqeq
        if (idCardLast == idCardY[idCardMod]) {
          return true
        } else {
          return '身份证号码错误！'
        }
      }
    } else {
      return true
    }
  } else {
    return '身份证格式不正确'
  }
}

/**
 * 根据身份类型验证身份证
 * */
export function authentication(type = 0, val) {
  if (type === 1 || (!type && val.toString().length === 18)) {
    return isCardID(val ? val.toString() : '')
  } else {
    return isCardIDTwo(val ? val.toString() : '')
  }
}

// 数字格式货币符号 万元
export function formatWY(val) {
  const c = (val / 10000).toString()
  console.log('计算返回', c, val)
  // const x = c.split('.')
  // if (x && x.length > 1 && x[1] && x[1].length > f) {
  //     x[1] = x[1].slice(0, f)
  //     console.log('拼接', x)
  //     return x[0] + (x[1].length > 0 ? ('.' + x[1]) : '')
  // }
  return c
}

export function tableStat(val) {
  let stat = ['进行中', '待审批', '已通过', '未通过', '未通过', '已撤销']
  let statClass = ['processing', 'processing', 'passed', 'refuse', 'refuse', 'cancel']
  let index = stat.indexOf(val)
  if (index !== -1) {
    return 'stat-block ' + statClass[index]
  }
}

export function tableStatus(val) {
  if (statusType[val]) {
    return 'stat-block ' + statusType[val].class
  }
}

/* arrbuffer 格式下载 */
export function downArrbuffer(data, name) {
  const link = document.createElement('a')
  const blogw = new Blob([data], { type: "application/vnd.ms-excel;charset=UTF-8" })
  const objUrl = window.URL.createObjectURL(blogw)
  link.href = objUrl
  link.download = name
  link.click()
  window.URL.revokeObjectURL(objUrl)
}

/* zip 格式下载 */
export function downArrZip(data, name) {
  const link = document.createElement('a')
  const blogw = new Blob([data], { type: "application/zip;charset=UTF-8" })
  const objUrl = window.URL.createObjectURL(blogw)
  link.href = objUrl
  link.download = name
  link.click()
  window.URL.revokeObjectURL(objUrl)
}


// 获取自定义状态的名称
export const getStatusShowText = (item) => {
  const status = item.approving.status
  const approver = item.approving.approver || []
  const step = item.approving.step
  const text = statusType[status].text
  const curflow = approver[step] || {}
  if (curflow.customStatus && status === 0) {
    return curflow.customStatus
  } else if (curflow.customText && status === 1) {
    return curflow.customText.agree.showText
  } else if (curflow.customText && status === 2) {
    return curflow.customText.refused.showText
  } else {
    return text
  }
}

/**
 *
 * @param {*} item 带有approving的对象
 * @return
 */
export const getStatusBtnText = (item) => {
  if (!item.approving) return false
  const approver = item.approving.approver || []
  const step = item.approving.step
  const curflow = approver[step] || {}
  let list = []
  if (curflow.customText) {
    const agree = curflow.customText.agree.btnText
    const refused = curflow.customText.refused.btnText
    list = [agree, refused]
    return list
  } else {
    return false
  }
}

// 去除富文本的color设置
export const removeColorAttribute = (htmlContent) => {
  // 正则表达式匹配字体颜色设置
  const regex = /style="color:[^;]+;?"|color:[^;]+;?/gi;
  // 替换掉所有的字体颜色设置
  return htmlContent.replace(regex, '');
}

// 获取用户真实手机号
export const getUserRealPhone = async (userId) => {
  let val = ''
  const query = {
    userId: userId,
    fieldname: 'phone',
  }

  const { code, data } = await getusersensitivedata(query)
  if (code === 0 && data.phone) {
    const privateKey = '8c252bf645a7dd1ca9611edd6b7266fab3d8506da83f41273b540210c43eda0c'
    let phone = data.phone
    // 后端生成的密文可能会补位 看返回的头两个字符是不是04 如果有04那需要去掉
    phone = phone.startsWith('04') ? phone.substring(2) : phone
    const decryptedData = sm2.doDecrypt(phone, privateKey)
    if (decryptedData) val = decryptedData
  }
  return val
}

export const confileRes = function (file) {
  return file.indexOf('confiles/') > -1 ? file : '/confiles/' + file
}

export function searchNav(val, reg) {
  let date = reg && reg !== '' ? searchNavExg(val, reg) : val
  var a = [];
  date.forEach(el => {
    a.push({
      title: el.categoryName,
      icon: el.category.pic,
      stat: true,
      value: []
    });
  });
  let obj = {};
  a = a.reduce((cur, next) => {
    obj[next.title] ? "" : (obj[next.title] = true && cur.push(next));
    return cur;
  }, []); //设置cur默认类型为数组，并且初始值为空的数组

  date.forEach(item => {

    for (var i in a) {
      if (item.categoryName == a[i].title) {
        a[i].value.push(item);
      }
    }
  });
  // console.log('a:', a)
  return a
}

export function searchNavExg(val, reg) {
  let res = reg.toLowerCase()
  let date = []
  let regs = new RegExp(res)
  val.forEach(item => {
    let toString = item.appname.toLowerCase()
    if (regs.test(toString)) {
      date.push(item)
    }
  })
  return date
}

// 传参进来设置了默认值 先弄联系人控件
export async function defaultValuesForParameterTransmission(date, val = {}, isAddName = false) {
  const datas = cloneDeep(date)
  const obj = cloneDeep(val)
  for (const data of datas) {
    let key = data.title + '_' + data.type
    if (isAddName) {
      key += '_' + data.name
      if (data.type === 'relation-user' && !Array.isArray(obj[key])) {
        obj[key] = [obj[key]]
      }
    }

    if (data.type === 'relation-user' && data.bindfieldList && data.bindfieldList.length > 0 && obj[key].length > 0) {
      const li = [...new Set(data.bindfieldList)]
      for (const key in li) {
        // 这边写是因为  把原有的控件删了 这边的配置信息没删
        const ele = li[key]
        const [title] = ele.split('_')
        const isIn = Boolean(datas.find(item => (item.title === title)))
        if (!isIn) {
          const idx = data.bindfieldList.findIndex(item => item === ele)
          data.bindfieldList.splice(idx, 1)
        }
      }

      if (data.bindfieldList.length === 0) {
        continue
      }
      const userInfoKeys = {
        '姓名': 'realname',
        '登录名': 'username',
        '联系电话': 'realphone',
        '出生日期': 'birthday',
        '身份证': 'realidcard',
        '性别': 'sex'
      }
      const bindfieldList = data.bindfieldList
      const res = await getnewuserbindmsg({ userId: obj[key][0].userId })
      let looktype = 0
      const info = cloneDeep(res.data)
      for (const key in res.data) {
        if (key === '部门：班级' && res.data[key][0]) {
          looktype = res.data[key][0].looktype
        }
        if (key.includes('部门')) {
          if (res.data[key][0]) {
            info[key] = res.data[key][0].name
          } else {
            info[key] = ''
          }
        }
      }
      const userInfo = info

      bindfieldList.forEach(async item => {
        // 跟绑定的那个控件做个匹配
        const fliedIndex = date.findIndex(ruleItem => { return `${ruleItem.title}_${ruleItem.type}` === item })
        if (fliedIndex !== -1) {
          const flied = date[fliedIndex]
          // 两边不匹配就返回
          if (flied.bindfieldKey !== `${data.title}_${data.type}`) return false
          const bindfield = flied.bindfield // 要回填的字段
          // 联动出来的没有该字段 去请求一下
          let value = userInfo[bindfield] !== undefined ? userInfo[bindfield] : userInfo[userInfoKeys[bindfield]]
          if (bindfield === '性别') {
            value = value ? '女' : '男'
          }
          if (value && value.search('userfiles') !== -1) {
            value = this.$url + value.replace('userfiles', 'conflies')
          }
          const bindnewFiled = flied.bindnewFiled
          if (bindnewFiled && bindnewFiled[1] && isStandardClass(value, 'class')) {
            value = getClassInfo(value, bindnewFiled[1], looktype)
          }
          if (item.includes('organization')) {
            value = res.data['部门']
          }
          if (bindfield !== '无') {
            if (isAddName) {
              const [title] = item.split('_')
              const val = datas.find(f => f.title === title)
              obj[`${item}_${val.name}`] = value
            } else {
              obj[item] = value
            }
          }
        }
      })
    }
  }
  return obj
}

/** 加法运算 **/
export function accAdd(arg1, arg2) {
  var r1, r2, m, c;
  try {
    r1 = arg1.toString().split(".")[1].length;
  }
  catch (e) {
    r1 = 0;
  }
  try {
    r2 = arg2.toString().split(".")[1].length;
  }
  catch (e) {
    r2 = 0;
  }
  c = Math.abs(r1 - r2);
  m = Math.pow(10, Math.max(r1, r2));
  if (c > 0) {
    var cm = Math.pow(10, c);
    if (r1 > r2) {
      arg1 = Number(arg1.toString().replace(".", ""));
      arg2 = Number(arg2.toString().replace(".", "")) * cm;
    } else {
      arg1 = Number(arg1.toString().replace(".", "")) * cm;
      arg2 = Number(arg2.toString().replace(".", ""));
    }
  } else {
    arg1 = Number(arg1.toString().replace(".", ""));
    arg2 = Number(arg2.toString().replace(".", ""));
  }
  return (arg1 + arg2) / m;
}

/**
 * 定义 HEX 颜色到 RGBA 的转换
 * */
export function hexToRGBA(hex, opacity) {
  console.log("hex==", hex);
  // 检查是否为 RGB 格式
  if (/^rgb/i.test(hex)) {
    return hex; // 如果是 RGB 格式，直接返回
  }
  if (!hex) return ''
  // 去除 '#' 字符，并使用内置的 parseInt 函数将颜色值转换为十进制数
  let r = parseInt(hex.slice(1, 3), 16);
  let g = parseInt(hex.slice(3, 5), 16);
  let b = parseInt(hex.slice(5, 7), 16);

  // 返回 rgba 格式的颜色字符串
  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
}


/**
 * 
 * 
*/
export const calculateSchedule = ({ reservationDays = 1, gapDays = 1, value, model = 'week' }) => {
  const dates = [];
  let now = new Date();
  if (value) {
    now = new Date(value);
  }
  const gapCount = model === 'week' ? 7 : 1
  for (let i = 0; i < reservationDays; i++) {
    const date = new Date(now);
    let gap = ((gapDays + 1) * gapCount) * i
    date.setDate(date.getDate() + gap);
    const format = dayjs(date).format('YYYY-MM-DD')
    dates.push(format);
  }
  if (reservationDays === 1) {
    // 加这个是因为预约控件必须是两个元素
    dates.push(dates[0])
  }
  return dates;
}
